import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
// Public Pages
import { HomePage } from './pages/HomePage';
import { LoginPage } from './pages/auth/LoginPage';
import { SignupPage } from './pages/auth/SignupPage';
import { ForgotPasswordPage } from './pages/auth/ForgotPasswordPage';
import { VerifyEmailPage } from './pages/auth/VerifyEmailPage';
// Onboarding Pages
import { WelcomePage } from './pages/onboarding/WelcomePage';
import { ProfilePage } from './pages/onboarding/ProfilePage';
import { PreferencesPage } from './pages/onboarding/PreferencesPage';
import { BusinessPage } from './pages/onboarding/BusinessPage';
import { BusinessDetailsPage } from './pages/onboarding/BusinessDetailsPage';
import { BusinessReadinessPage } from './pages/onboarding/BusinessReadinessPage';
import { SummaryPage } from './pages/onboarding/SummaryPage';
// App Pages
import { AppDashboard } from './pages/AppDashboard';
import { LegalHealthCheckAccess } from './pages/LegalHealthCheckAccess';
import { AppReports } from './pages/AppReports';
import { AppProfile } from './pages/AppProfile';
import { SharedReportViewer } from './pages/SharedReportViewer';
export function AppRouter() {
  return <AuthProvider data-id="element-1">
      <BrowserRouter data-id="element-2">
        <Routes data-id="element-3">
          {/* Public Routes */}
          <Route path="/" element={<HomePage data-id="element-5" />} data-id="element-4" />
          <Route path="/login" element={<LoginPage data-id="element-7" />} data-id="element-6" />
          <Route path="/signup" element={<SignupPage data-id="element-9" />} data-id="element-8" />
          <Route path="/forgot-password" element={<ForgotPasswordPage data-id="element-11" />} data-id="element-10" />
          <Route path="/verify-email" element={<VerifyEmailPage data-id="element-13" />} data-id="element-12" />

          {/* Onboarding Routes (Requires Auth, but NOT onboarded) */}
          <Route path="/onboarding/welcome" element={<ProtectedRoute requireOnboarded={false} data-id="element-15">
                <WelcomePage data-id="element-16" />
              </ProtectedRoute>} data-id="element-14" />
          <Route path="/onboarding/profile" element={<ProtectedRoute requireOnboarded={false} data-id="element-18">
                <ProfilePage data-id="element-19" />
              </ProtectedRoute>} data-id="element-17" />
          <Route path="/onboarding/preferences" element={<ProtectedRoute requireOnboarded={false} data-id="element-21">
                <PreferencesPage data-id="element-22" />
              </ProtectedRoute>} data-id="element-20" />
          <Route path="/onboarding/business" element={<ProtectedRoute requireOnboarded={false} data-id="element-24">
                <BusinessPage data-id="element-25" />
              </ProtectedRoute>} data-id="element-23" />
          <Route path="/onboarding/business-details" element={<ProtectedRoute requireOnboarded={false} data-id="element-27">
                <BusinessDetailsPage data-id="element-28" />
              </ProtectedRoute>} data-id="element-26" />
          <Route path="/onboarding/business-readiness" element={<ProtectedRoute requireOnboarded={false} data-id="element-30">
                <BusinessReadinessPage data-id="element-31" />
              </ProtectedRoute>} data-id="element-29" />
          <Route path="/onboarding/summary" element={<ProtectedRoute requireOnboarded={false} data-id="element-33">
                <SummaryPage data-id="element-34" />
              </ProtectedRoute>} data-id="element-32" />

          {/* Authenticated App Routes (Requires Auth AND Onboarded) */}
          <Route path="/app" element={<ProtectedRoute data-id="element-36">
                <AppDashboard data-id="element-37" />
              </ProtectedRoute>} data-id="element-35" />
          <Route path="/app/legal-health-check" element={<ProtectedRoute data-id="element-39">
                <LegalHealthCheckAccess data-id="element-40" />
              </ProtectedRoute>} data-id="element-38" />
          <Route path="/app/reports" element={<ProtectedRoute data-id="element-42">
                <AppReports data-id="element-43" />
              </ProtectedRoute>} data-id="element-41" />
          <Route path="/app/profile" element={<ProtectedRoute data-id="element-45">
                <AppProfile data-id="element-46" />
              </ProtectedRoute>} data-id="element-44" />

          {/* Shared Report (Public) */}
          <Route path="/shared-report/:id" element={<SharedReportViewer data-id="element-48" />} data-id="element-47" />

          {/* Catch all */}
          <Route path="*" element={<Navigate to="/" replace data-id="element-50" />} data-id="element-49" />
        </Routes>
      </BrowserRouter>
    </AuthProvider>;
}